"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ModalConfirmationRenderer");

class ModalConfirmationComponent extends EventEmitter {
    /**
     * Displays a confirmation message to the user.
     * @param {string} msg - Message to present to the user.
     * @param {object} [opts] - Optional parameters.
     * @param {string} [title=undefined] - A Title to present to the user.
     *
     * @param {ActionDefinition} [confirmDetails=undefined] - Details about the confirm action definition.
     * @param {ActionDefinition} [rejectDetails=undefined] - Details about the reject action definition.
     */
    constructor(msg, opts) {
        super();
        this._message = msg || "";
        this._enableHtml = _.get(opts, "enableHtml", false);
        this._title = _.get(opts, "title", "Please Confirm");
        this._confirmationationDetails = _.defaults({}, _.get(opts, "confirmDetails"), {
            type: "text",
            text: "Yes",
        });
        this._rejectionDetails = _.defaults({}, _.get(opts, "rejectDetails"), {
            type: "text",
            text: "No",
        });

        this._renderer = new Renderer(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
            this._confirmationationDetails = undefined;
            this._rejectionDetails = undefined;
            this._title = undefined;
            this._message = undefined;
            this._userFeedbackContext = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    set "$teve.ui.context"(cntxt) {
        //jshint ignore:line
        this._userFeedbackContext = cntxt;
    }

    get title() {
        return this.getTitle();
    }

    getTitle() {
        return this._title;
    }

    get msg() {
        return this.getMsg();
    }

    getMsg() {
        return this._message;
    }

    get enableHtml() {
        return this._enableHtml;
    }

    get confirmationDeets() {
        return this.getConfirmationDeets();
    }

    getConfirmationDeets() {
        return this._confirmationationDetails;
    }

    get rejectionDeets() {
        return this.getRejectionDeets();
    }

    getRejectionDeets() {
        return this._rejectionDetails;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START PUBLIC ACTION METHODS             */
    /*******************************************/

    confirm() {
        this._userFeedbackContext.resolve();
    }

    reject() {
        this._userFeedbackContext.reject();
    }

    /*******************************************/
    /* END PUBLIC ACTION METHODS               */
    /*******************************************/
}

module.exports = ModalConfirmationComponent;
